import Minilog from "minilog";
import FetchBackend from "./minilogFetchBackend";

const initialize = () => {
  if (!process.env.SERVER) {
    Minilog.enable().pipe(
      new FetchBackend({
        url: window.__BASE_URL__ + "/client-log-handler",
        interval: 10000,
      })
    );
  }
};

const getLogger = () => {
  return Minilog("client");
};

export default {
  initialize,
  getLogger,
};
